import styled, { css } from 'styled-components'
import Box from 'components/shared/Box'

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    // Hide checkbox visually but remain accessible to screen readers.
    // Source: https://polished.js.org/docs/#hidevisually
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`

export const checkedStyles = css`
    position: relative;
    background: ${({ theme }) => theme.colors.primary_500};
`
export const uncheckedStyles = css`
    border: 2px solid ${({ theme }) => theme.colors.grayscale_400};
    background-color: ${({ theme }) => theme.colors.grayscale_0};
`
interface CheckProps {
    isChecked: boolean
}
export const CustomCheckbox = styled(Box)<CheckProps>`
    width: 24px;
    height: 24px;
    border-radius: 4px;
    ${({ isChecked }) => (isChecked ? checkedStyles : uncheckedStyles)};
`

export const CheckboxLabel = styled(Box)`
    cursor: pointer;

    &:focus-within:has(input) {
        ${CustomCheckbox} {
            border: 2px solid ${({ theme }) => theme.colors.secondary_500};
        }
    }
    &:has(a:focus) {
        ${CustomCheckbox} {
            border: 2px solid ${({ theme }) => theme.colors.grayscale_400};
        }
    }
`
